import React, { useState } from 'react';

const Testimonials = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      text: "Kaskomla ilgili her konuda hızlı ve güvenilir bir destek aldım. Poliçe işlemlerimi kolayca tamamladım, çok memnunum.",
      author: "Kemal Y."
    },
    {
      text: "Tüm süreci öyle güzel ve anlaşılır bir şekilde anlattılar ki hiç tereddüt etmeden poliçemi yaptırdım. Kesinlikle tavsiye ederim.",
      author: "Zehra A."
    },
    {
      text: "Trafik sigortamı yenilemek için en iyi fiyatları bulmamda yardımcı oldular. Samimi ve profesyonel bir ekip, teşekkür ederim.",
      author: "Yılmaz O."
    },
    {
      text: "DASK poliçemi yaptırırken aklımdaki her soruya sabırla cevap verdiler. Çok içten bir ekip.",
      author: "Hediye T."
    },
    {
      text: "Sağlık sigortamı yaptırmak için aradım, çok ilgilendiler ve en uygun teklifi sundular. Çok memnun kaldım.",
      author: "Burak O."
    }
  ];
  

  return (
    <section className="py-16 bg-white relative overflow-hidden">
      {/* Hafif mavi ışık */}
      <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-[#0064ff]/10 to-transparent pointer-events-none"></div>
      
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12 text-[#13122b]">
          Mutlu <span className="text-[#0064ff]">Müşterilerimizin </span> Değerli Yorumları
        </h2>

        <div className="max-w-3xl mx-auto">
          {/* Testimonial Box */}
          <div className="bg-white rounded-xl p-8 shadow-lg relative">
            <p className="text-lg italic text-gray-600 leading-relaxed mb-6">
              "{testimonials[currentTestimonial].text}"
            </p>
            <p className="font-bold text-[#13122b] text-lg">
              - {testimonials[currentTestimonial].author}
            </p>

            {/* Dekoratif Elemanlar */}
            <div className="absolute -top-3 -left-3 w-8 h-8 bg-[#0064ff]/30 rounded-full"></div>
            <div className="absolute -bottom-3 -right-3 w-8 h-8 bg-[#13122b]/30 rounded-full"></div>
          </div>

          {/* Navigation Dots */}
          <div className="flex justify-center mt-8 space-x-3">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentTestimonial(index)}
                className={`w-4 h-4 rounded-full transition ${
                  currentTestimonial === index
                    ? 'bg-[#0064ff] scale-110'
                    : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
